"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageEnUSMessages = exports.packageZhCNMessages = exports.$t = void 0;
exports.mergeIntlMessages = mergeIntlMessages;
exports.setGlobalPackageIntlMessages = setGlobalPackageIntlMessages;
const zh_CN_json_1 = __importDefault(require("./lang/zh-CN.json"));
exports.packageZhCNMessages = zh_CN_json_1.default;
const en_US_json_1 = __importDefault(require("./lang/en-US.json"));
exports.packageEnUSMessages = en_US_json_1.default;
var intl_1 = require("./intl");
Object.defineProperty(exports, "$t", { enumerable: true, get: function () { return intl_1.$t; } });
function mergeIntlMessages(appZhCN, appEnUS, locale) {
    const isEn = locale === 'en-US';
    return {
        ...(isEn ? en_US_json_1.default : zh_CN_json_1.default),
        ...(isEn ? appEnUS : appZhCN),
    };
}
function setGlobalPackageIntlMessages(locale) {
    const isEn = locale === 'en-US';
    const packageIntlMessages = {
        current: isEn ? en_US_json_1.default : zh_CN_json_1.default,
        zhCN: zh_CN_json_1.default,
        enUS: en_US_json_1.default,
    };
    window.__MARS_PACKAGE_INTL_MESSAGES__ = packageIntlMessages;
}
